import BossReporter, { createAttaReporter, createBossReporter } from './middleware/boss-report';
import UniversalReporter from './middleware/universal-report';
import plugin, { useReporter } from './plugins';
export default plugin;
export { BossReporter, createAttaReporter, createBossReporter, UniversalReporter, useReporter, };
